// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import pagosnetLogoSrc from './pagosnet.svg';

export function PagosnetForm(): Node {
  const allFeatures = useCurrentAllFeatures();
  return (
    <IfFeature allFeatures={allFeatures} wanted="display_pagosnet_instructions">
      <div style={{ gridColumn: '1/3', display: 'flex' }}>
        <img src={pagosnetLogoSrc} alt="Pagosnet" />
        <p style={{ opacity: 0.5, marginLeft: '1em' }}>
          Al generar tu número de recaudación tendrás 72 horas para finalizar tu pago.
        </p>
      </div>
    </IfFeature>
  );
}
